export default __webpack_public_path__ + "static/media/stocktaking.8dacc3fa.jpg";